import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;

export async function GetPipelineStages(callback, pipelineId) {
    cancel && cancel();

    const uri = 'api/crmPipelineFront/getPipelineOptions';

    try {
        axios
            .get(
                uri,
                { params: { pipelineId } },
                {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json;charset=UTF-8',
                    },
                }
            )
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                return callback({ success: false, data: null });
            });
    } catch (error) {
        return callback({ success: false, data: null });
    }
}

export async function FetchPipeline(dispatch) {
    cancel && cancel();

    const uri = `api/crm/pipeline`;

    try {
        axios
            .get(uri, {
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                var deals = GatherAllDeals(response.data.pipelineStages);

                dispatch({
                    type: 'UPDATE_PIPELINE_PIPELINESTAGES_AND_DEALS',
                    pipeline: response.data,
                    pipelineStages: response.data.pipelineStages,
                    deals: deals,
                });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }
            });
    } catch (error) {
        console.error(error);
    }
}

export async function FetchPipelineActiveDeal(id, setIsLoading, dispatch) {
    cancel && cancel();

    const uri = `api/crm/pipeline`;

    try {
        axios
            .get(uri, {
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                var deals = GatherAllDeals(response.data.pipelineStages);

                dispatch({
                    type: 'UPDATE_PIPELINE_PIPELINESTAGES_AND_DEALS',
                    pipeline: response.data,
                    pipelineStages: response.data.pipelineStages,
                    deals: deals,
                });
                dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: deals[id] });
                setIsLoading(false);
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                    //TODO Something when request is cancelled?
                } else {
                    //const error = thrown.response;
                }
                setIsLoading(false);
            });
    } catch (error) {
        console.error(error);
        setIsLoading(false);
    }
}

const GatherAllDeals = (pipelineStages) => {
    var deals = [];
    pipelineStages.map((elem) => {
        deals = deals.concat(elem.deals);
        return null;
    });

    return deals;
};
